import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hashicorpNomad = defineConnector({
  identifier: "hashicorpNomad",
  name: "HashiCorp Nomad",
  tagLine: "Workload orchestration platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.hashicorp\\.cloud/.*",
  auth: (app) =>
    headerAuth([{ name: "X-Nomad-Token", value: app.secret.aclToken }]),
  steps: [
    {
      title: "Enter your Nomad instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "nomad.your-company.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your ACL token",
      items: [
        {
          kind: "markdown",
          content:
            "Create an ACL token in Nomad with the appropriate policies. See the [API docs](https://developer.hashicorp.com/nomad/api-docs) for details.",
        },
        {
          kind: "input",
          label: "ACL token",
          required: true,
          target: { kind: "secrets", field: "aclToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/v1/jobs`,
  },
});
